import React from 'react';
import PropTypes from 'prop-types';

const YAHOO_DEFAULT_COLOR = '#5F01D1';

export default function Yahoo({ logoColor, logoWidth, logoHeight }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={logoWidth} height={logoHeight} viewBox="0 0 27 24" fill="none">
            <title>Calendar Attachment Yahoo</title>
            <path
                d="M0.00195312 5.84259H5.15065L8.14872 13.5125L11.1858 5.84259H16.1983L8.65032 24H3.60518L5.67147 19.1886L0.00211257 5.84259H0.00195312ZM22.0356 11.9711H16.4211L21.4042 0L26.9982 0.000239163L22.0356 11.9711ZM17.8918 13.1169C19.6145 13.1169 21.0109 14.5134 21.0109 16.2357C21.0109 17.9582 19.6145 19.3547 17.8918 19.3547C16.1694 19.3547 14.7732 17.9582 14.7732 16.2357C14.7732 14.5134 16.1696 13.1169 17.8918 13.1169Z"
                fill={logoColor || YAHOO_DEFAULT_COLOR}
            />
        </svg>
    );
}

Yahoo.defaultProps = {
    logoColor: null,
    logoWidth: 27,
    logoHeight: 24,
};
Yahoo.propTypes = {
    logoColor: PropTypes.string,
    logoWidth: PropTypes.number,
    logoHeight: PropTypes.number,
};
